import { httpClient } from '@/config/httpClient';

export async function postUnlinkDebitNotes(batchDebitNoteIds: string[]) {
  return httpClient.post('/batch-debit-note/unlink-debit-notes', {
    batchDebitNoteIds,
  });
}
